import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./store";
import {Provider} from "react-redux";
import {BrowserRouter as Router} from "react-router-dom";
import {createBrowserHistory} from "history";

const appHistory = createBrowserHistory();
ReactDOM.render(
  <Provider store={store}>
    <Router history={appHistory}>
      <App />
    </Router>
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
